/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default () => (dispatch) => {
	dispatch({ type: actions.REPORT_BUILDER_STOP });
};
